import { Component, Input } from '@angular/core';
import { mapButtonToCommand, } from '@sitecore-jss/sitecore-jss/utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
export class EditFrameComponent {
    dataSource;
    buttons;
    title;
    tooltip;
    cssClass;
    parameters;
    sitecore;
    isEditing = false;
    frameProps = {};
    chromeData = '';
    ngOnChanges() {
        this.isEditing = this.sitecore.context.pageEditing || false;
        if (!this.isEditing) {
            return;
        }
        this.frameProps.class = 'scLooseFrameZone';
        if (this.cssClass) {
            this.frameProps.class = `${this.frameProps.class} ${this.cssClass}`;
        }
        // item uri for edit frame target
        if (this.dataSource) {
            const route = this.sitecore.route;
            const databaseName = this.dataSource.databaseName || route?.databaseName;
            const language = this.dataSource.language || this.sitecore.context.language;
            this.frameProps.sc_item = `sitecore://${databaseName}/${this.dataSource.itemId}?lang=${language}`;
        }
        this.chromeData = this.buildChromeData();
    }
    buildChromeData() {
        const chromeData = {
            displayName: this.title,
            expandedDisplayName: this.tooltip,
        };
        if (this.dataSource) {
            chromeData.contextItemUri = this.frameProps.sc_item;
        }
        chromeData.commands = this.buttons?.map((value) => {
            return mapButtonToCommand(value, this.dataSource?.itemId, this.parameters);
        });
        return JSON.stringify(chromeData);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EditFrameComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EditFrameComponent, selector: "sc-edit-frame,[sc-edit-frame]", inputs: { dataSource: "dataSource", buttons: "buttons", title: "title", tooltip: "tooltip", cssClass: "cssClass", parameters: "parameters", sitecore: "sitecore" }, usesOnChanges: true, ngImport: i0, template: `
    <ng-template #childContent>
      <ng-content></ng-content>
    </ng-template>
    <div
      *ngIf="isEditing; else elseBlock"
      [class]="frameProps.class"
      [attr.sc_item]="frameProps.sc_item"
    >
      <span class="scChromeData">{{ chromeData }}</span>
      <ng-container *ngTemplateOutlet="childContent"></ng-container>
    </div>
    <ng-template #elseBlock>
      <ng-container *ngTemplateOutlet="childContent"></ng-container>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EditFrameComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-edit-frame,[sc-edit-frame]',
                    template: `
    <ng-template #childContent>
      <ng-content></ng-content>
    </ng-template>
    <div
      *ngIf="isEditing; else elseBlock"
      [class]="frameProps.class"
      [attr.sc_item]="frameProps.sc_item"
    >
      <span class="scChromeData">{{ chromeData }}</span>
      <ng-container *ngTemplateOutlet="childContent"></ng-container>
    </div>
    <ng-template #elseBlock>
      <ng-container *ngTemplateOutlet="childContent"></ng-container>
    </ng-template>
  `,
                }]
        }], propDecorators: { dataSource: [{
                type: Input
            }], buttons: [{
                type: Input
            }], title: [{
                type: Input
            }], tooltip: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], parameters: [{
                type: Input
            }], sitecore: [{
                type: Input
            }] } });
